// src/components/hero/Hero.jsx
import { Box, Grid } from "@mui/material";
import HeroContent from "./HeroContent";
import HeroImage from "./HeroImage";
import HeroVideoBackground from "./HeroVideoBackground";

const Hero = () => {
  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        minHeight: "700px",
        overflow: "hidden",
      }}
    >
      {/* Use Video Background */}
      <HeroVideoBackground />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          alignItems: "center",
          px: { xs: 2, sm: 4, md: 6, lg: 8 },
        }}
      >
        <Grid 
          container 
          spacing={4} 
          alignItems="center"
          sx={{
            flexDirection: { xs: "column-reverse", md: "row" },
          }}
        >
          {/* Content column - Left side */}
          <Grid item xs={12} md={6} lg={6}>
            <HeroContent />
          </Grid>
          
          {/* Image column - Right side */}
          <Grid 
            item 
            xs={12} 
            md={6} 
            lg={6}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
            }}
          >
            <HeroImage />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Hero;